import api from 'service/api'

const dponetAPI = api.create('supplierPortal', false)

const resend = async ({ companySupplierToken, ...params }) => {
  return await dponetAPI.post(
    `/two_factor_authentication/${companySupplierToken}/resend`,
    params,
  )
}

export default {
  resend,
}
